<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>처방문의 등록</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">처방 문답</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th><span class="emp">문의 사항</span></th>
                <td colspan="3">
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.inquiry_details"
                  />
                </td>
              </tr>
              <tr>
                <th><span class="emp">카테고리</span></th>
                <td colspan="3">
                  <div class="form_select">
                    <b-form-select v-model="formulaQnaInfo.prescribe_category" style="width: 310px">
                      <b-form-select-option value="">선택</b-form-select-option>
                      <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                    </b-form-select>
                  </div>
                </td>
              </tr>
              <tr>
                <th><span class="emp">주소증</span></th>
                <td colspan="3">
                  <textarea
                    name=""
                    id=""
                    class="form_control"
                    placeholder="환자가 불편하거나 개선을 원하느 부분을 위주로 기재해주세요."
                    v-model="formulaQnaInfo.chief_complaint"
                  >
                  </textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">환자 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>나이</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.age"
                  />
                </td>
                <th>성별</th>
                <td>
                  <div class="form_inline">
                    <div class="form_radio">
                        <input type="radio" id="radio2" name="radio"  value="M" v-model="formulaQnaInfo.gender">
                        <label for="radio2">남</label>
                    </div>
                    <div class="form_radio">
                        <input type="radio" id="radio3" name="radio" value="F" v-model="formulaQnaInfo.gender" >
                        <label for="radio3">여</label>
                    </div> 
                  </div> 
                </td>
              </tr>
              <tr>
                <th>키</th>
                <td>
                  <input
                    type="text"
                    class="form_control limit"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.height"
                  />
                  cm
                </td>
                <th>몸무게</th>
                <td>
                  <input
                    type="text"
                    class="form_control limit"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.weight"
                  />
                  kg
                </td>
              </tr>
              <tr>
                <th>혈압</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.blood_pressure"
                  />
                </td>
                <th>맥박수</th>
                <td>
                  <input
                    type="text"
                    class="form_control limit"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.pulse_rate"
                  />
                  회/분
                </td>
              </tr>
              <tr>
                <th>사상체질</th>
                <td colspan="3">
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.sasang_constitution"
                  />
                </td>
              </tr>
              <tr>
                <th>기왕력</th>
                <td colspan="3">
                  <textarea
                    name=""
                    id=""
                    class="form_control"
                    placeholder=" 과거에 앓았던 질병, 외상, 수술 이력등을 포함한 개인의 병력(病歷)에 대해서 기재"
                    v-model="formulaQnaInfo.past_medical_history"
                  >
                  </textarea>
                </td>
              </tr>
              <tr>
                <th>진맥</th>
                <td colspan="3">
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.pulse_diagnosis"
                  />
                </td>
              </tr>
              <tr>
                <th>복진</th>
                <td colspan="3">
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.abdominal_exam"
                  />
                </td>
              </tr>
              <tr>
                <th>대변</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.bowel_condition"
                  />
                </td>
                <th>소변</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.urinary_condition"
                  />
                </td>
              </tr>
              <tr>
                <th>한출</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.sweating_pattern"
                  />
                </td>
                <th>심계</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.palpitations"
                  />
                </td>
              </tr>
              <tr>
                <th>수면</th>
                <td colspan="3">
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.sleep_condition"
                  />
                </td>
              </tr>
              <tr>
                <th>갈증</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.thirst"
                  />
                </td>
                <th>물 선호</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="차가운 물/따뜻한 물 어느 쪽을 선호하는지"
                    v-model="formulaQnaInfo.water_preference"
                  />
                </td>
              </tr>
              <tr>
                <th>소화 상태</th>
                <td colspan="3">
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.digestion_condition"
                  />
                </td>
              </tr>
              <tr>
                <th>식용</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.appetite"
                  />
                </td>
                <th>붓기</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.edema"
                  />
                </td>
              </tr>
              <tr>
                <th>한열</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.cold_heat_sensation"
                  />
                </td>
                <th>두통</th>
                <td>
                  <input
                    type="text"
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.headache"
                  />
                </td>
              </tr>
              <tr>
                <th>기타</th>
                <td colspan="3">
                  <textarea
                    name=""
                    id=""
                    class="form_control"
                    placeholder="입력해주세요"
                    v-model="formulaQnaInfo.etc"
                  >
                  </textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bottom_box bn">
          <button class="btn btn_md btn_darkbrown" @click="fn_move_list_page">
            목록
          </button>
          <button class="btn btn_md btn_brown" @click="fn_save">처방문의 등록</button>
        </div>
      </article>
    </section>
    <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        :closeEventValue="closeEventValue"
        @closeEvent="oncCloseEvent"
        v-on:update:showSetting="fn_showSet"
    />
    <alert-modal 
          :id="'confirm'"
          :text="'저장하시겠습니까?'" 
          :btnLeft="'취소'" 
          :btnRight="'확인'" 
          :oneBtn="true"
          :isShow="comfirmAlertShow"
          :className="'btn_brown'"
          @callback="fn_alert_close"
      />
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";
export default {
  components: {
    'alert-modal' : AlertModal,
  },
  mixins: [commonUtil, alertutill],
  data() {
    return {
      formulaQnaInfo : {
        clinic_doctor_id : '',
        formula_inquiry_seq : '',
        inquiry_details : '',
        prescribe_category : '',
        chief_complaint : '',
        age : '',
        gender : 'M',
        height : '',
        weight : '',
        blood_pressure : '',
        pulse_rate : '',
        per_minute : '',
        sasang_constitution : '',
        past_medical_history : '',
        pulse_diagnosis : '',
        abdominal_exam : '',
        bowel_condition : '',
        urinary_condition : '',
        sweating_pattern : '',
        palpitations : '',
        sleep_condition : '',
        thirst : '',
        water_preference : '',
        digestion : '',
        general_condition : '',
        appetite : '',
        edema : '',
        cold_heat_sensation : '',
        headache : '',
        etc : '',
        status : ''
      },
      comfirmAlertShow : false,
      prescrbeCategoryList : [],
    };
  },
  async created(){
    this.formulaQnaInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

    //처방 카테고리
    this.prescrbeCategoryList = await this.getCode('GC00000015'); 
  },
  methods :{
    fn_save(){
      if(this.formulaQnaInfo.inquiry_details == ''){
        let msg = "문의사항을 입력해주세요.";
        this.fn_open_alert(msg); 
        return;
      }

      if(this.formulaQnaInfo.prescribe_category == ''){
        let msg = "카테고리를  입력해주세요.";
        this.fn_open_alert(msg); 
        return;
      }

      if(this.formulaQnaInfo.chief_complaint == ''){
        let msg = "주소증을 입력해주세요.";
        this.fn_open_alert(msg); 
        return;
      }

      this.comfirmAlertShow = true;
    },
    fn_alert_close(type){

      this.comfirmAlertShow = false;
                    
      if(type == 'ok'){

        console.log("@@@@ save formulaQnaInfo : %o",this.formulaQnaInfo);

          axios
          .post("/api/user/board/savePormulaQnaInfo", this.formulaQnaInfo)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              
              //this.$emit('callback', res.data.patient_seq);
              let msg = "저장되었습니다.";
              this.fn_open_alert_close(msg); 
              
          })
          .catch((err) => console.log(err));
      }

    },
    fn_move_list_page(){
        this.$store.dispatch('detailSearchInfo/setSearchId', ''); 
        this.$router.push("/formulaQna");
    },
    oncCloseEvent(){
        this.fn_move_list_page();
    }
  }
};
</script>
